import React, { ReactNode } from 'react';

import Card from '@/src/components/common/Elements/Card/Card';
import { cn } from '@/src/util/ui';

type FileCardProps = {
  onClick?: (event: any) => void;
  children?: ReactNode;
  className?: string;
  isSelected?: boolean;
};

const FileCard = ({ className, onClick, children }: FileCardProps) => {
  return (
    <Card
      className={cn(
        'tw-group',
        'tw-flex tw-items-center',
        'tw-border-[1px] tw-border-solid tw-border-cfo-grey-500',
        'tw-rounded-[10px]',
        'tw-px-[10px] tw-pt-[5px] tw-pb-[5px] tw-mr-[2px]',
        'hover:tw-border-cfo-blue-300 hover:tw-bg-cfo-blue-200 hover:tw-cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      {children}
    </Card>
  );
};

export default FileCard;
